import React from 'react';
import { Link } from 'react-router-dom';
import { useTheme } from '../contexts/ThemeContext';
import GS1DigitalLinkEditor from '../components/GS1DigitalLinkEditor';
import { useContent } from '../hooks/useContent';

const GS1EditorPage = () => {
  const { isDark } = useTheme();
  const { content, loading: contentLoading } = useContent('gs1EditorPage');

  if (contentLoading || !content) {

    return (
      <div className={`pt-16 min-h-screen flex items-center justify-center ${isDark ? 'bg-dark-900' : 'bg-gray-50'}`}>
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-500"></div>
      </div>
    );
  }

  return (
    <div className={`min-h-screen ${
      isDark ? '' : 'bg-gray-50'
    }`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 md:py-8">
        <div className="flex items-center justify-between mb-6 md:mb-8">
          <div className="flex items-center">
            <Link
              to="/dashboard"
              className={`mr-3 md:mr-4 p-2 transition-colors duration-200 ${
                isDark 
                  ? 'text-gray-400 hover:text-white' 
                  : 'text-gray-500 hover:text-gray-900'
              }`}
            >
              <svg className="w-5 h-5 md:w-6 md:h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
              </svg>
            </Link>
            <div>
              <h1 className={`text-xl md:text-3xl font-bold ${
                isDark ? 'text-white' : 'text-gray-900'
              }`}>{content.pageTitle}</h1>
              <p className={`text-sm md:text-base ${
                isDark ? 'text-gray-400' : 'text-gray-600'
              }`}>{content.pageSubTitile}</p>
            </div>
          </div>
        </div>

        <GS1DigitalLinkEditor />
        
        <div className="mt-6 text-center md:text-right">
          <Link to="/dashboard/qr" className={`text-sm transition-colors ${
            isDark 
              ? 'text-primary-400 hover:text-primary-300' 
              : 'text-primary-500 hover:text-primary-600'
          }`}>
	  {content.footerLink}
          </Link>
        </div>
      </div>
    </div>
  );
};

export default GS1EditorPage;
